import {get,post} from '../paymentLinkHttp'
class PartialPaymentAPIService {
    static get_link_details = (slug) => {
        let endpoint = `partial-payment/${slug}`
        return get(endpoint);
    }

    static get_payment_history = (queryData) => {
        let endpoint = "partial-payment/payment_history/";
        return get(endpoint, queryData)
    }

    static pay_amount = (queryData) => {
        const csrfToken = this.getCookie('csrftoken');
        const headers = {
            'X-CSRFToken': csrfToken,
            'Content-Type': 'application/json',
          };
        let endpont ="partial-payment/pg_transaction_call/";
        return post(endpont, queryData,headers)
    }

    static getCookie(name) {
        const cookieValue = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        return cookieValue ? cookieValue.pop() : '';
    }

    static get_txn_details = (url,txn_id) => {
        let endpoint = `partial-payment/response/${url}/${txn_id}`
        return get(endpoint);
    }

}

export default PartialPaymentAPIService;